export default class Header {
    constructor() {
        this.header = document.querySelector('header');
        if (!this.header) return;

        this.state = {
            isScrolled: false,
            isHidden: false,
            lastScrollY: 0,
            scrollThreshold: 100
        };

        //this.detectBurgerClick();
        //this.updateHeaderState();
    }

    updateHeaderState() {
        const currentScrollY = window.scrollY;
        const scrollingDown = currentScrollY > this.state.lastScrollY;
        const scrollingUp = currentScrollY < this.state.lastScrollY;

        // Add/remove scrolled class
        if (currentScrollY > 50) {
            if (!this.state.isScrolled) {
                this.header.classList.add('is-scrolled');
                this.state.isScrolled = true;
                this.animateScrolledState(true);
            }
        } else {
            if (this.state.isScrolled) {
                this.header.classList.remove('is-scrolled');
                this.state.isScrolled = false;
                this.animateScrolledState(false);
            }
        }

        // Hide/show header on scroll
        if (currentScrollY > this.state.scrollThreshold) {
            if (scrollingDown && !this.state.isHidden) {
                this.hideHeader();
            } else if (scrollingUp && this.state.isHidden) {
                this.showHeader();
            }
        }

        this.state.lastScrollY = currentScrollY;
    }


    initScrollBehavior() {
        let ticking = false;

        const handleScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    this.updateHeaderState();
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Initial check
        this.updateHeaderState();
    }


    detectBurgerClick = () => {
        const burger = document.querySelector('#burger');
        const megaMenu = document.querySelector('#megaMenu');

        if (burger) {
            burger.addEventListener('click', () => {
                const isActive = burger.classList.contains('active');

                if (isActive) {
                    burger.classList.remove('active');
                    burger.setAttribute('aria-expanded', 'false');

                    document.dispatchEvent(new CustomEvent('menu:close'));
                } else {
                    burger.classList.add('active');
                    burger.setAttribute('aria-expanded', 'true');

                    document.dispatchEvent(new CustomEvent('menu:open'));
                }

                if (megaMenu) {
                    megaMenu.classList.toggle('open');
                    document.querySelector('html').classList.toggle('no-scroll');
                    document.querySelector('body').classList.toggle('no-scroll');
                }
            });
        } else {
            console.error('L\'élément #burger n\'existe pas dans le DOM.');
        }
    };

}